import { Navigate, Route, Routes } from "react-router-dom";
import { useEnvironment } from "../../../core/Global";
import SignUpComplete from "../views/SignUpComplete";
import SignUpStart from "../views/SignUpStart";
import SignUpStripeRedirect from "../views/SignUpStripeRedirect";



function SignUpRoutes() {
    const env = useEnvironment();

    // Sign-ups closed for this site (env.json "signUp"): /join goes back to sign in.
    if (!env.signUp) return <Navigate to="/auth/login" replace />;

    return (
        <Routes>
            <Route path="/join" element={<SignUpStart />} />
            <Route path="/join/stripe/success/:sessionId" element={<SignUpStripeRedirect success />} />
            <Route path="/join/stripe/failed/:sessionId" element={<SignUpStripeRedirect />} />
            <Route path="/join/:token" element={<SignUpComplete />} />
        </Routes>
    );
  }
  
  export default SignUpRoutes;